import styled from 'styled-components'
import { rem, spacing } from '@unbounded/unbounded-components'

export const Content = styled.div`
  min-width: ${rem(174)};
  margin-top: ${spacing(-0.75)};
`
